import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import ajaxProject from "../../util/remote/ajaxProject";
import Loader from "../../Components/Common/Loader";
import AppContainer from "../../Components/Structure/AppContainer";
import useStateCallback from "../../util/customHooks/useStateCallback";
import TableHeader from "../../Components/Common/TableHeader";
import AddHardware from "../../Components/ProjectTracker/AddHardware";
import UpdateHardware from "../../Components/ProjectTracker/UpdateHardware";
import * as XLSX from "xlsx"; // Import xlsx library
import jsPDF from "jspdf";
import "jspdf-autotable";

function ListHardwareProducts() {
  const [loading, setLoading] = useState(false);
  const [productList, setProductList] = useState(false);
  const { batch, id } = useParams();
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState(false);
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState("");

  const [modal, setModal] = useStateCallback(false);

  const handleModal = () => {
    setModal(false, () =>
      setModal(
        <AddHardware id={id} batch={batch} f={listProducts} isOpen={true} />
      )
    );
  };

  const handleModal2 = (e, item) => {
    setModal(false, () =>
      setModal(
        <UpdateHardware
          id={id}
          hardware_id={item.id}
          batch={batch}
          f={listProducts}
          isOpen={true}
          pole_id={item.pole_id}
          nb_cables={item.nb_cables}
          nb_ofc12={item.nb_ofc12}
          nb_ofc144={item.nb_ofc144}
          nb_ofc48={item.nb_ofc48}
          trunk={item.trunk}
          estimated_hardware={item.estimated_hardware}
          Nb_spriral_11={item.Nb_Spriral_11}
          Nb_spriral_15={item.Nb_Spriral_15}
          Nb_DeadN_11={item.Nb_DeadN_11}
          Nb_DeadN_15={item.Nb_DeadN_15}
          contractor={item.contractor}
        />
      )
    );
  };

  useEffect(() => {
    SearchHardware();
  }, [searchQuery, batch]);

  const SearchHardware = async () => {
    setLoading(true);
    const server_response = await ajaxProject.searchHardware(searchQuery);
    setLoading(false);
    if (searchQuery.length > 0) {
      if (server_response.status === "OK") {
        setProductList(server_response.details);
      } else {
        setProductList(server_response.details);
      }
    } else {
      setLoading(true);
      const server_response = await ajaxProject.fetchHardwareBatchProducts(
        batch
      );
      setLoading(false);

      if (server_response.status === "OK") {
        setProductList(server_response.details);
      }
    }
  };

  const listProducts = async () => {
    setLoading(true);
    const server_response = await ajaxProject.fetchHardwareBatchProducts(batch);
    setLoading(false);

    if (server_response.status === "OK") {
      setProductList(server_response.details);
    }
  };

  const exportToExcel = () => {
    // Prepare data for export
    if (Array.isArray(productList)) {
      const data = productList.map((item, index) => ({
        pole_id: item.pole_id,
        nb_cables: item.nb_cables,
        nb_ofc12: item.nb_ofc12,
        nb_ofc48: item.nb_ofc48,
        trunk: item.trunk,
        estimated_hardware: item.estimated_hardware,
        Nb_Spriral_11: item.Nb_Spriral_11,
        Nb_Spriral_15: item.Nb_Spriral_15,
        Nb_DeadN_11: item.Nb_DeadN_11,
        Nb_DeadN_15: item.Nb_DeadN_15,
        contractor: item.contractor,
        final_hardware_used: item.final_hardware_used,
        install_date: item.install_date,
      }));
      // Create a worksheet from your table data
      const ws = XLSX.utils.json_to_sheet(data);

      // Create a workbook with the worksheet
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Hardware");

      // Generate a file name
      const fileName = "hardware_data.xlsx";

      // Save the file
      XLSX.writeFile(wb, fileName);
    } else {
      toast.error("Cannot export empty table to excel");
    }
  };

  return (
    <AppContainer title="Batch Hardware List">
      <>
        <Toaster position="top-center" reverseOrder={false} />
        {modal}
        <Link
          to={`/project/hardware/${id}`}
          className="btn btn-primary btn-sm mb-2">
          Back To Hardware
        </Link>
        <div className="mt-4 mb-4">
          <div class="input-group">
            <input
              class="form-control"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search for..."
              type="text"
            />
            <span class="input-group-btn">
              <button
                class="btn ripple btn-primary"
                style={{
                  height: 26,
                  borderTopRightRadius: 25,
                  borderBottomRightRadius: 25,
                }}
                type="button">
                <span class="input-group-btn">
                  <i class="fa fa-search"></i>
                </span>
              </button>
            </span>
          </div>
        </div>
        <div className="card custom-card">
          <div className="card-body map-card">
            <button
              style={{ float: "right" }}
              onClick={exportToExcel}
              className="btn btn-sm btn-secondary mb-3 ml-3 mr-3">
              Export to Excel
            </button>
            <TableHeader
              title="Upload Batch Products"
              viewButton={
                <a
                  href="#"
                  onClick={handleModal}
                  className="btn btn-primary btn-sm"
                  style={{ float: "right" }}>
                  Add Hardware
                </a>
              }
            />

            <div className="table-responsive">
              <div className="border-top mt-3"></div>
              {loading && <Loader />}
              {!loading && (
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>pole_id</th>
                      <th>nb_cables</th>
                      <th>nb_ofc12</th>
                      <th>nb_ofc144</th>
                      <th>nb_ofc48</th>
                      <th>trunk</th>
                      <th>estimated_hardware</th>
                      <th>Nb_spriral_11</th>
                      <th>Nb_spriral_15</th>
                      <th>Nb_DeadN_11</th>
                      <th>Nb_DeadN_15</th>
                      <th>contractor</th>
                      <th>final_hardware_used</th>
                      <th>install_date</th>
                      <th>edit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!Array.isArray(productList) && <tr>No hardware found</tr>}
                    {Array.isArray(productList) &&
                      productList.map((item, key) => (
                        <tr key={key}>
                          <td>{item.pole_id}</td>
                          <td>{item.nb_cables}</td>
                          <td>{item.nb_ofc12}</td>
                          <td>{item.nb_ofc144}</td>
                          <td>{item.nb_ofc48}</td>
                          <td>{item.trunk}</td>
                          <td>{item.estimated_hardware}</td>
                          <td>{item.Nb_Spriral_11}</td>
                          <td>{item.Nb_Spriral_15}</td>
                          <td>{item.Nb_DeadN_11}</td>
                          <td>{item.Nb_DeadN_15}</td>
                          <td>{item.contractor}</td>
                          <td>{item.final_hardware_used}</td>
                          <td>{item.install_date}</td>
                          <td>
                            <a
                              onClick={(e) => handleModal2(e, item)}
                              className="btn btn-primary btn-sm">
                              Edit
                            </a>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </>
    </AppContainer>
  );
}

export default ListHardwareProducts;
